import React, { useState, useEffect } from 'react'
import Wheel from 'components/instant-win/instant-win-wheel/Wheel'
import star from 'images/star.svg'
import SoccerBall from 'images/inline/soccerball.svg'
import Marker from 'images/inline/marker.svg'
import './InstantWinWheel.scss'

const InstantWinWheel = ({
  data = [],
  button,
  wheelConfig,
  wheelTheme,
  handleAfterSpin,
}) => {
  let prizeNumber = 0
  if (wheelConfig.prizeId != null) {
    if (wheelTheme) {
      // Multiple slices may share the same prizeId; pick one at random
      const matchingIndices = data
        .map((item, i) => (item.id === wheelConfig.prizeId ? i : -1))
        .filter(i => i !== -1)
      prizeNumber = matchingIndices.length > 0
        ? matchingIndices[Math.floor(Math.random() * matchingIndices.length)]
        : 0
    } else {
      prizeNumber = data.findIndex(item => item.id === wheelConfig.prizeId)
    }
  }

  console.log(`prizeNumber`, prizeNumber)

  const [isCampbells, setIsCampbells] = useState(false)

  useEffect(() => {
    if (!wheelTheme) {
      try {
        let isCampbells = [...document.body.classList].some(
          className => className.indexOf('campbell') > -1,
        )
        setIsCampbells(isCampbells)
      } catch (e) {
        console.log(e)
      }
    }
  }, [wheelTheme])

  // Determine colors: backend theme takes priority, then Campbell's, then defaults
  let backgroundColors, textColors, outerBorderColor, innerBorderColor, radiusLineColor
  let outMostBorderStyle
  let markerStyle = {}
  let starStyle = {}
  let iconImageUrl = null
  let sliceBorderColor = null
  let sliceBorderWidth = 0

  if (wheelTheme) {
    // Per-slice colors are already on each data item's style property;
    // these arrays are fallbacks for Wheel.jsx's cycling logic if style is missing
    backgroundColors = ['#D5D8DC', '#808B96']
    textColors = ['#183E88', '#FFF']
    outerBorderColor = wheelTheme.innerWheelBorderColor || '#EA983E'
    innerBorderColor = wheelTheme.innerWheelBorderColor || '#EA983E'
    radiusLineColor = 'transparent'
    outMostBorderStyle = {
      borderColor: wheelTheme.outerWheelBorderColor || '#393939',
    }
    markerStyle = {
      '--ticker-border-color': wheelTheme.tickerBorderColor || undefined,
      '--ticker-fill-color': wheelTheme.tickerColor || undefined,
    }
    if (wheelTheme.iconBorderColor) {
      starStyle = { border: `3px solid ${wheelTheme.iconBorderColor}`, boxSizing: 'border-box' }
    }
    iconImageUrl = wheelTheme.iconImageUrl
    if (wheelTheme.sliceBorderColor && wheelTheme.sliceBorderWidth) {
      sliceBorderColor = wheelTheme.sliceBorderColor
      sliceBorderWidth = wheelTheme.sliceBorderWidth
    }
  } else if (isCampbells) {
    backgroundColors = ['#5a5d5f', '#d5d8dc', '#bf8f00', '#808c96', '#d5d8dc', '#bf8f00', '#808c96']
    textColors = ['#fff', "#5a5d5f", '#fff']
    outerBorderColor = '#ffffff'
    innerBorderColor = '#393939'
    radiusLineColor = 'red'
    outMostBorderStyle = { borderColor: '#393939' }
  } else {
    backgroundColors = ['#D5D8DC', '#808B96', '#EAECEE', '#FFF', '#ABB2B9']
    textColors = ['#EA983E', '#183E88', '#3B8EDE']
    outerBorderColor = '#EA983E'
    innerBorderColor = '#EA983E'
    radiusLineColor = 'transparent'
    outMostBorderStyle = { borderColor: '#393939' }
  }

  const renderCenterIcon = () => {
    if (iconImageUrl) {
      return <img src={iconImageUrl} alt="center icon" />
    }
    if (isCampbells) {
      return <SoccerBall />
    }
    return <img src={star} alt="star" />
  }

  return (
    <div className="center">
      <div className="mostOuterBorder">
        <div className="marker-wrapper" style={markerStyle}>
          <Marker className="marker" />
        </div>
        <div className="extraBorder" style={outMostBorderStyle}></div>
        <Wheel
          mustStartSpinning={wheelConfig.shouldSpin}
          startingOptionIndex={0}
          prizeNumber={prizeNumber}
          data={data}
          backgroundColors={backgroundColors}
          outerBorderWidth={15}
          outerBorderColor={outerBorderColor}
          innerBorderWidth={65}
          innerBorderColor={innerBorderColor}
          radiusLineWidth={0}
          radiusLineColor={radiusLineColor}
          textColors={textColors}
          fontSize={26}
          textDistance={70}
          onStopSpinning={handleAfterSpin}
          spinDuration={0.5}
          perpendicularText={!wheelTheme || wheelTheme.textOrientation !== 'vertical'}
          sliceBorderColor={sliceBorderColor}
          sliceBorderWidth={sliceBorderWidth}
        />
        <div className="star" style={starStyle}>
          {renderCenterIcon()}
        </div>
      </div>
      <div className="button-container">{button}</div>
    </div>
  )
}

export default InstantWinWheel
